import { FC } from 'react'
import Sheet from 'react-modal-sheet'
import { IconButton, Typography } from '@material-tailwind/react'
import { PiX } from 'react-icons/pi'
import { useScreenBreakpoint } from '../hooks/toolkit'
import { ExperienceSidebar } from './ExperienceSidebar'
import { AgamiExperience } from '../types/supabase'

interface ExperienceSettingsProps {
  experienceDetails: AgamiExperience
  refetchExperienceDetails: () => void
  closeSidebar: () => void
  sidebarIsClosed: boolean
}

export const ExperienceSettings: FC<ExperienceSettingsProps> = ({
  experienceDetails,
  refetchExperienceDetails,
  closeSidebar,
  sidebarIsClosed,
}) => {
  const screenBreakpoint = useScreenBreakpoint()
  return (
    <>
      {screenBreakpoint === 'sm' ? (
        // BOTTOM SHEET
        <Sheet isOpen={!sidebarIsClosed} onClose={closeSidebar}>
          <Sheet.Container>
            <Sheet.Header className="p-4 flex justify-between items-center">
              <Typography variant="h4">Experience Settings</Typography>
              <IconButton size="sm" variant="text" color="gray" onClick={closeSidebar}>
                <PiX className="h-5 w-5 text-primary dark:text-base-gray-500" />
              </IconButton>
            </Sheet.Header>
            <Sheet.Content>
              <Sheet.Scroller draggableAt="both">
                <ExperienceSidebar
                  experienceDetails={experienceDetails}
                  refetchExperienceDetails={refetchExperienceDetails}
                  closeSidebar={closeSidebar}
                  sidebarIsClosed={sidebarIsClosed}
                  isInBottomSheet
                />
              </Sheet.Scroller>
            </Sheet.Content>
          </Sheet.Container>
          <Sheet.Backdrop />
        </Sheet>
      ) : (
        // SIDEBAR
        <div
          className={`transition-all duration-[400ms] overflow-hidden ${!sidebarIsClosed ? 'w-[350px] 2xl:w-[400px] 3xl:w-[500px] ml-4 max-h-[9999px]' : 'w-0 ml-0 max-h-0'}`}
        >
          <div
            className="w-[350px] 2xl:w-[400px] 3xl:w-[500px] max-w-full transition-opacity duration-[500ms]"
            style={{
              opacity: !sidebarIsClosed ? 1 : 0,
            }}
          >
            <ExperienceSidebar
              experienceDetails={experienceDetails}
              refetchExperienceDetails={refetchExperienceDetails}
              closeSidebar={closeSidebar}
              sidebarIsClosed={sidebarIsClosed}
            />
          </div>
        </div>
      )}
    </>
  )
}
